import api from '../axiosConfig';
import { RATES } from '../config/apiEndpoints';

export const RateService = {
    getRatePlans: async (tenantId, params = {}) => {
        try {
            const axiosParams = { ...params };
            if (params.page !== undefined) {
                axiosParams.page = params.page + 1;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            const response = await api.get(RATES.PLANS, { 
                params: axiosParams,
                headers: { 'x-tenant-id': tenantId }
            });
            if (params.page !== undefined) return response.data;
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService getRatePlans error:', error);
            throw error;
        }
    },

    createRatePlan: async (planData, tenantId) => {
        try {
            const response = await api.post(RATES.PLANS, planData, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService createRatePlan error:', error);
            throw error;
        }
    },

    updateRatePlan: async (id, updates, tenantId) => {
        try {
            const response = await api.patch(RATES.BY_ID(id), updates, {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService updateRatePlan error:', error);
            throw error;
        }
    },

    deleteRatePlan: async (id, tenantId) => {
        try {
            const response = await api.delete(RATES.BY_ID(id), {
                headers: { 'x-tenant-id': tenantId }
            });
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService deleteRatePlan error:', error);
            throw error;
        }
    },

    getRateCalendar: async (params) => {
        try {
            const response = await api.get(RATES.CALENDAR, { params });
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService getRateCalendar error:', error);
            throw error;
        }
    },

    getStayFees: async (params = {}) => {
        try {
            const axiosParams = { ...params };
            if (params.page !== undefined) {
                axiosParams.page = params.page + 1;
            } else if (params.noPagination || params.noPaging) {
                axiosParams.noPagination = true;
            } else {
                axiosParams.noPagination = true;
            }
            const response = await api.get(RATES.STAY_FEES.BASE, { params: axiosParams });
            if (params.page !== undefined) return response.data;
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService getStayFees error:', error);
            throw error;
        }
    },

    createStayFee: async (feeData) => {
        try {
            const response = await api.post(RATES.STAY_FEES.BASE, feeData);
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService createStayFee error:', error);
            throw error;
        }
    },

    updateStayFee: async (id, feeData) => {
        try {
            const response = await api.patch(RATES.STAY_FEES.BY_ID(id), feeData);
            return response.data?.data || response.data || response;
        } catch (error) {
            console.error('RateService updateStayFee error:', error);
            throw error;
        }
    },

    exportRatePlans: async (tenantId, format = 'csv') => {
        try {
            const response = await api.get(RATES.EXPORT, {
                params: { format },
                headers: { 'x-tenant-id': tenantId },
                responseType: 'blob'
            });
            return response;
        } catch (error) {
            console.error('RateService exportRatePlans error:', error);
            throw error;
        }
    },
};
